(function ($) {

    // only for pos
    if (!document.querySelector('body.pos-page')) {
        return;
    }
    //Count for preprepare orders and show on side bar.
    const IDLE_TIMEOUT = 20_000;
    let lastActivity = Date.now();

    function record_last_activity() {
        lastActivity = Date.now();
    }

    ['mousemove', 'scroll', 'keydown', 'touchstart'].forEach(evt =>
        document.addEventListener(evt, record_last_activity, {passive: true})
    );

    const POLL_INTERVAL = 20_000;
    let lastCount = parseInt($('.sidebar__badge-count').attr('data-count'));

    function pollPreprepareCount() {
        gp_ajax({
            url: ghostpress_params.ajax_url,
            type: 'post',
            dataType: 'json',
            data: {
                action: 'pos_order',
                pos_action: 'get_preprepare_count'
            }
        })
            .done(response => {
                if (!response.success) return;
                const newCount = parseInt(response.data.count) || 0;
                $('.sidebar__badge-count').attr('data-count', newCount);

                if (newCount !== lastCount &&
                    document.body.classList.contains('gp-endpoint-pos-orders') &&
                    (Date.now() - lastActivity) > IDLE_TIMEOUT
                ) {
                    window.location.reload();
                }

                lastCount = newCount;
            })
            .fail(() => {
                console.warn('POS: nepodařilo se načíst počet předpřipravených objednávek');
            });
    }

    setInterval(pollPreprepareCount, POLL_INTERVAL);


    if (!document.querySelector('body.gp-endpoint-pos-orders')) {
        return;
    }
    let empty_state = document.querySelectorAll('.pos__orders-empty');

    function get_orders() {
        return document.querySelectorAll('.pos__orders_order');
    }

    /**
     * Update count
     */
    function update_counts() {
        let counters = {};
        let total = 0;
        get_orders().forEach(function (order) {
            total += 1;
            const status = order.getAttribute('data-filter-status');
            if (!counters[status]) {
                counters[status] = 0;
            }
            counters[status] += 1;
        });
        document.querySelectorAll('.pos__switcher_button-count').forEach(function (counter) {
            const counter_status = counter.parentNode.getAttribute('data-filter-status');
            if (counter_status) {
                if (!counters[counter_status]) {
                    counters[counter_status] = 0;
                }
                counter.innerText = counters[counter_status];
            } else {
                counter.innerText = total;
            }
        });
    }

    update_counts();

    /**
     * Main app
     */

    let app_status = {
        status_filter: '',
        sort_column: '',
        sort_reverse: false,
        search: '',
    };
    let old_status = {...app_status};

    let defaultTab = sessionStorage.getItem('ordersTab');
    if (defaultTab) {
        app_status.status_filter = defaultTab;
    }

    function update_app() {
        let do_filter = false;
        if (old_status.sort_column !== app_status.sort_column || old_status.sort_reverse !== app_status.sort_reverse) {
            render_sort_column();
            sort_orders();
        }
        if (old_status.status_filter !== app_status.status_filter) {
            render_status_filter();
            do_filter = true;
        }
        if (old_status.search !== app_status.search) {
            do_filter = true;
        }
        if (do_filter) {
            filter_orders();
        }
        old_status = {...app_status};
    }

    function render_status_filter() {
        // remove old classes
        document.querySelectorAll(".pos__switcher_button.--active").forEach(function (item) {
            item.classList.remove('--active');
        });
        // add new class
        document.querySelectorAll('.pos__switcher_button[data-filter-status="' + app_status.status_filter + '"]').forEach(function (item) {
            item.classList.add('--active');
        });
    }

    function render_sort_column() {
        // remove old classes
        document.querySelectorAll(".pos__orders_filter-col[data-sort-by].--active").forEach(function (item) {
            item.classList.remove('--active');
            item.classList.remove('--reverse');
        });
        // add new class
        document.querySelectorAll('.pos__orders_filter-col[data-sort-by="' + app_status.sort_column + '"]').forEach(function (item) {
            item.classList.add('--active');
            if (app_status.sort_reverse) {
                item.classList.add('--reverse');
            }
        });
    }

    /**
     * Sorting
     */
    const compare_numbers = function (a, b) {
        const compare = b.val - a.val;
        return compare === 0 ? a.number - b.number : compare;
    }
    const compare_strings = function (a, b) {
        const valA = a.val; // ignore upper and lowercase
        const valB = b.val; // ignore upper and lowercase
        if (valA < valB) {
            return -1;
        }
        if (valA > valB) {
            return 1;
        }

        // equal names - use numbers for sorting
        return a.number - b.number;
    }

    function sort_orders() {
        let value_col = 'data-' + app_status.sort_column;
        let order_values = [];
        // get values
        get_orders().forEach(function (order) {
            order_values.push({
                'val': order.getAttribute(value_col),
                'order': order,
                'number': order.getAttribute('data-order-number'),
            })
        });
        // sort orders
        let sort_function = compare_strings;
        if (app_status.sort_column === 'total' || app_status.sort_column === 'order-number') {
            sort_function = compare_numbers;
        }

        order_values.sort(sort_function);
        // sort nodes
        order_values.forEach(function (item) {
            if (app_status.sort_reverse) {
                item.order.parentNode.prepend(item.order);
            } else {
                item.order.parentNode.appendChild(item.order);
            }
        });
    }

    /**
     * Status Filter
     */

    function filter_orders() {
        const status_filter = app_status.status_filter;
        const search_term = app_status.search.toLowerCase().trim();
        const terms = search_term.split(/\s+/).filter(t => t);
        let visible_count = 0;
        get_orders().forEach(function (order) {
            let display = false;
            if (!status_filter || status_filter == order.getAttribute('data-filter-status')) {
                if (terms.length) {
                    const content = order.getAttribute('data-filter-search');
                    let match = true;
                    terms.forEach(function (term) {
                        if (match && content.indexOf(term) === -1) {
                            match = false;
                        }
                    });
                    if (match) {
                        display = true;
                    }
                } else {
                    display = true;
                }
            }

            if (display) {
                order.style.display = '';
                visible_count += 1;
            } else {
                order.style.display = 'none';
            }
        });
        empty_state.forEach(function (node) {
            node.style.display = visible_count ? 'none' : '';
        });
    }

    /**
     * App changes
     */

    app_status.sort_column = 'status';
    update_app();


    $(".pos__switcher_button").on("click", function () {
        let newTab = this.getAttribute('data-filter-status');
        app_status.status_filter = this.getAttribute('data-filter-status');
        sessionStorage.setItem('ordersTab', newTab);
        update_app();
    })

    $('.pos__orders_filter-col[data-sort-by]').on('click', function () {
        const sort_column = this.getAttribute('data-sort-by');
        if (sort_column === app_status.sort_column) {
            app_status.sort_reverse = !app_status.sort_reverse;
        } else {
            app_status.sort_column = sort_column;
            app_status.sort_reverse = false;
        }
        update_app();
    });
    $('.pos__search_input').on('input', function (e) {
        // remove status filter for new searches
        if(!app_status.search && this.value){
            app_status.status_filter = '';
        }
        app_status.search = this.value;
        update_app();
    }).on('keydown', function (e) {
        if (e.key === 'Escape') {
            let $inputs = $('.pos__search_input');
            $inputs.val(''); // clear value
            $inputs.trigger('input');
        }
    })
    $('.pos__search_form').on('submit', function (e) {
        e.preventDefault();
        app_status.search = $(this).find('.pos__search_input').val();
        update_app();
    })
    $('.pos__search_clear').on('click', function (e) {
        let $inputs = $('.pos__search_input');
        $inputs.val(''); // clear value
        $inputs.trigger('input');
    });
})(jQuery);